<template>
    <div class="flex items-center justify-between">
        <div v-if="stylingNewVersion" class="py-1">
            <div class="flex items-center pt-0.5 md:pt-1">
                <img :src="`/img/icons/svg/${serviceSlug}.svg`" :alt="`${serviceSlug} icon`" class="opacity-75" style="width: 26px;" />
                <div class="pl-3 lg:pl-4">
                    <span class="pr-2 xs:pr-0 text-base md:text-base font-medium text-gray-900 ">
                            {{ title }}
                        </span>
                        <span
                            v-if="
                                this.quote?.coupon?.value &&
                                ((this.quote?.coupon?.value === 'FREEONWARD' &&
                                    this.title === 'Onward Travel') ||
                                    (this.quote?.coupon?.value === 'FREEMISFUEL' &&
                                        this.title === 'Misfuel Assistance'))
                            "
                            class="px-2 font-bold text-xs sm:text-sm rounded-md inline-block uppercase py-1 sm:py-1 xs:ml-1"
                            :style="{ 
                                backgroundColor: hexColor ? hexToRgba(hexColor, 0.4) : hexToRgba('#ef4444', 0.9), 
                                color: hexColor ? '#404040' : 'white' 
                            }"
                        >
                            Free
                    </span>
                </div>
            </div>
            <span
                class="text-sm leading-normal text-gray-500"
                :class="
                    [ showDescription ? 'block' : 'hidden', removable ? 'mt-2' : 'mt-1' ]
                "
                v-html="description"
            >
            </span>
        </div>
        <div v-else class="flex items-center" :class="showDescription ? 'py-1' : 'py-1 lg:py-0'">
            <svg
                v-if="showShield"
                class="block lg:block flex-shrink-0"
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="28"
                viewBox="0 0 65.729 70.107"
            >
                <defs></defs>
                <g transform="translate(-16 0.005)">
                    <path
                        :class="{
                            'shield-check-a': !free,
                            'free-shield-a': free,
                        }"
                        d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z"
                        transform="translate(0 0)"
                    />
                    <path
                        :class="{
                            'shield-check-b': !free,
                            'free-shield-b': free,
                        }"
                        d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z"
                        transform="translate(-75.994 -127.76)"
                    />
                </g>
            </svg>

            <div
                class="pl-3 lg:pl-4"
                :class="{
                    'flex items-center w-full': removable,
                }"
            >
                <span>
                    <span
                        class="text-base md:text-sm font-medium text-gray-900 flex items-center"
                         :class="showDescription ? 'h-auto' : 'h-auto lg:h-9'"
                    >
                        <span class="pr-2">
                            {{ title }}
                        </span>
                        <span
                            v-if="
                                this.quote?.coupon?.value &&
                                ((this.quote?.coupon?.value === 'FREEONWARD' &&
                                    this.title === 'Onward Travel') ||
                                    (this.quote?.coupon?.value === 'FREEMISFUEL' &&
                                        this.title === 'Misfuel Assistance'))
                            "
                            class="px-2 font-bold text-xs sm:text-sm rounded-md inline-block uppercase py-1 sm:py-1"
                            :style="{ 
                                backgroundColor: hexColor ? hexToRgba(hexColor, 0.4) : hexToRgba('#ef4444', 0.9), 
                                color: hexColor ? '#404040' : 'white' 
                            }"
                        >
                            Free
                        </span>
                    </span>
                    <span
                        class="text-sm leading-normal text-gray-500"
                        :class="showDescription ? 'lg:block' : 'hidden'"
                    >
                        {{ description }}
                    </span>
                </span>
            </div>
        </div>
        <span v-if="removable" class="text-sm pl-2 ml-auto">
            <button
                class="relative inline-flex items-center py-1 border text-xs md:text-sm font-medium focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 rounded-md border-gray-300 bg-white text-gray-400 hover:bg-gray-50;"
                type="button"
                @click="remove(title)"
                :class="{
                    'hidden lg:hidden' :showDescription,
                    'px-2 sm:px-4' : stylingNewVersion,
                    'px-3 sm:px-4' : !stylingNewVersion
                }"
            >
                Remove
            </button>
        </span>

    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "ServiceInformation",
    props: {
        title: {
            type: String,
            default: "",
        },
        description: {
            type: String,
            default: "",
        },
        showShield: {
            type: Boolean,
            default: true,
        },
        removable: {
            type: Boolean,
            default: false,
        },
        free: {
            type: Boolean,
            default: false,
        },
        showDescription: {
            type: Boolean,
            default: false,
        },
        hexColor: {
            type: [String, null],
            default: null
        },
        stylingNewVersion: {
            type: Boolean,
            default: false,
        },
        serviceSlug: {
            type: String,
            default: "",
        },
    },
    methods: {
        remove(key) {
            this.$emit("remove-service", key);
        },
        hexToRgba(hex, alpha) {
            hex = hex.replace('#', '');
            const bigint = parseInt(hex, 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        }
    },
    computed: {
        ...mapGetters({
            quote: "quote",
        }),
    },
};
</script>

<style>
.free-shield-a {
    fill: #10b981;
}

.free-shield-b {
    fill: white;
}
</style>
